import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-fad3fa38"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["xlink:href"];
import { computed } from 'vue';
export default /*#__PURE__*/_defineComponent({
  props: {
    prefix: {
      type: String,
      required: false,
      default: 'icon'
    },
    icon: {
      type: String,
      required: true,
      default: ''
    },
    size: {
      type: [Array, Number, String],
      required: false,
      default: 16
    },
    spin: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const symbolId = computed(() => `#${props.prefix}-${props.icon}`);
    const getStyle = computed(() => {
      const {
        size
      } = props;
      let s = `${size}`;
      s = `${s.replace('px', '')}px`;
      const sArray = s.split(' ');
      return {
        width: sArray[0],
        height: sArray.length === 2 ? sArray[1] : sArray[0]
      };
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("svg", {
        class: _normalizeClass(['svg-icon', _ctx.$attrs.class, __props.spin && 'svg-icon-spin']),
        style: _normalizeStyle(_unref(getStyle)),
        "aria-hidden": "true"
      }, [_createElementVNode("use", {
        "xlink:href": _unref(symbolId)
      }, null, 8, _hoisted_1)], 6);
    };
  }
});